"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZTooltip = void 0;
const utils_1 = require("../../utils");
const ll_1 = require("../../languages/ll");
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const styled_components_1 = __importDefault(require("styled-components"));
const TooltipContainer = styled_components_1.default.div `
   display: inline-block;
`;
exports.ZTooltip = (props) => {
    const { languageId } = react_1.default.useContext(ll_1.llContext), localize = props.localize === undefined ? true : props.localize, content = localize && typeof props.title == "string"
        ? ll_1.ll({ key: props.title, languageId, variables: props.variables })
        : props.title, TitleContainer = styled_components_1.default.div `
         font-size: 12px;
         font-family: ${props => props.theme["font-family"]};
      `, formContext = react_1.default.useContext(utils_1.FrameContext);
    const StyledTooltip = react_1.default.useMemo(() => core_1.withStyles(props.muiStyles || {})(Tooltip_1.default), [props.muiStyles]);
    return (react_1.default.createElement(StyledTooltip, Object.assign({}, props, { PopperProps: {
            ...props.PopperProps,
            container: formContext.document.body
        }, title: react_1.default.createElement(TitleContainer, null, content) }),
        react_1.default.createElement(TooltipContainer, null, props.children)));
};
//# sourceMappingURL=ZTooltip.js.map